import axios from "axios";
import axiosMock from "axios-mock-adapter";
import * as faker from 'faker';
import crypto from "crypto";

const mock = new axiosMock(axios);

const docs = [];

for (let i = 0; i < 10; i++) {
    let numberOfTags = faker.datatype.number({min: 1, max: 3});
    let uuid = faker.datatype.uuid();

    docs.push({
        _id: faker.datatype.number(),
        md5: crypto.createHash('md5').update(uuid).digest('hex'),
        url: faker.image.image(),
        uuid: faker.datatype.uuid(),
        alt: faker.lorem.paragraph(),
        mimeType: 'image/jpeg',
        originalName: faker.system.commonFileName('jpg'),
        tags: faker.lorem.words(numberOfTags).split(' '),
        createdAt: faker.date.past(),
    });
}

mock.onGet(`${process.env.VUE_APP_SERVICE_URI_FILE}/api/images`, { params: {
        page: 1,
    }}).reply(200, {
    docs: docs,
});